







import { Component, Vue } from "vue-property-decorator";
import EmployeeStandByEditDayLine from "@/components/EmployeeStandByEditDayLine.vue";
import { Models } from "@/core/Export";
import store from "@/store";
@Component({
  components: { EmployeeStandByEditDayLine }
})
export default class EmployeeStandByEdit extends Vue {
  pagination = {
    rowsPerPage: 0
  };

  get standByEditColumns(): Array<any> {
    return [
      {
        name: "date",
        field: "date",
        label: this.$t("pages.employeeAttendDetails.date"),
        align: "left",
        style: "width: 105px;",
      },
      {
        name: "day",
        field: "day",
        label: this.$t("pages.employeeAttendDetails.day"),
        align: "left",
        style: "width: 105px;",
      },
      {
        name: "entry",
        field: "entry",
        label: this.$t("pages.standBy.startTimeText"),
        align: "left",
        style: "width: 140px;",
      },
      {
        name: "exit",
        field: "exit",
        label: this.$t("pages.standBy.endTimeText"),
        align: "left",
        style: "width: 140px;",
      },
      {
        name: "notes",
        field: "notes",
        label: this.$t("pages.employeeAttendDetails.notes"),
        align: "left"
      },
      {
        name: "total",
        field: "total",
        label: this.durationCaption,
        align: "left"
      }
    ];
  }

  //set total duration text
  get totalDurationText(): string {
    const editData = this.employeeStandByEditData;
    const data = editData && editData.data ? editData.data : [];
    let totalMinutes = 0;

    data.forEach((row) => {
      if (!row.startTimeText || !row.endTimeText) return;

      const durationText = Models.AppUtils.calculateDuration(row.startTimeText, row.endTimeText);
      if (!durationText || durationText === "00:00") return;

      totalMinutes += Models.AppUtils.getMinutes(durationText);
    });

    if (totalMinutes === 0) return "";

    const time = new Models.time("");
    time.fromMinutes(totalMinutes);
    return Models.AppUtils.formatTimePart(time.hours) + ":" + Models.AppUtils.formatTimePart(time.minutes);
  }

  //set duration caption
  get durationCaption(): string {
    let text = this.$t("pages.employeeAttendDetails.workingHoursActual").toString();
    if (this.totalDurationText) text = `${text} (${this.totalDurationText})`;
    return text;
  }

  get employeeStandByEditData() {
    return store.getters.employeeStandByEditData;
  }
}
